module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Object.keys(_vm.item).length > 0) ? _c('section', {
    staticClass: "content-item flexContainer full"
  }, [_c('div', {
    staticClass: "item flexContainer full ai-c xs-fd-c"
  }, [_c('div', {
    staticClass: "flexContainer size7of12 xs-w-full"
  }, [_c('figure', {
    staticClass: "jc-c ac-fs ai-fs size3of12 txtCenter m-w-mid xs-w-one-quart"
  }, [_c('SystemTypeIcon', {
    attrs: {
      "type": _vm.item.systemType && _vm.item.systemType.id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flexContainer size5of12 fd-c m-w-mid xs-w-three-quart"
  }, [(_vm.item.name !== '') ? _c('span', {
    staticClass: "list-item-name uppercase"
  }, [_vm._v(_vm._s(_vm.item.name))]) : _c('span', {
    staticClass: "list-item-name uppercase"
  }, [_vm._v("no name")]), _vm._v(" "), _c('span', {
    staticClass: "list-item-size"
  }, [_vm._v(_vm._s(_vm.item.size))]), _vm._v(" "), _c('span', {
    staticClass: "list-item-info uppercase"
  }, [_vm._v(_vm._s(_vm.item.brand.name))]), _vm._v(" "), (_vm.item.standDesign !== null) ? _c('span', {
    staticClass: "list-item-info uppercase"
  }, [_vm._v(_vm._s(_vm.item.standDesign.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flexContainer size4of12 fd-c mobileNot"
  }, [_c('span', {
    staticClass: "ff-light"
  }, [_c('span', {
    staticClass: "ff-bold"
  }, [_vm._v(_vm._s(_vm.$t("planoList.created")) + ":")]), _vm._v(" " + _vm._s(_vm.item.user.dateCreated) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ff-light"
  }, [_c('span', {
    staticClass: "ff-bold"
  }, [_vm._v(_vm._s(_vm.$t("planoList.by")))]), _vm._v(" " + _vm._s(_vm.item.user.firstname) + " " + _vm._s(_vm.item.user.lastname) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "ff-light"
  }, [_c('span', {
    staticClass: "ff-bold"
  }, [_vm._v("Visibility")]), _vm._v(" " + _vm._s(_vm.item.visiblility) + " (" + _vm._s(_vm.item.id) + ") ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flexContainer size3of12 xs-mt10"
  }, [_c('span', {
    staticClass: "list-item-status uppercase txtCenter",
    class: _vm.item.status
  }, [_vm._v(_vm._s(_vm.item.status))])]), _vm._v(" "), (_vm.item.actions) ? _c('div', {
    staticClass: "size2of12"
  }, _vm._l((_vm.item.actions), function(action, i) {
    return _c('button', {
      key: i,
      staticClass: "btn editBtn center uppercase",
      on: {
        "click": function($event) {
          _vm.actionEvent(action);
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t("displayer." + action.label)) + "\n            ")])
  })) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-277e34f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gui/list/Item.vue
// module id = 3087
// module chunks = 0